const DiscussionSavingsData =[
   {  //  student52
      "_id": {
        "$oid": "63d2f690efd24bab94ffeeda"
      },
      "gameID": "63cdd95d2904c3c3801b3dfe",
    "__v": 0,
  "currentlyActive": true,
  "dateAdded": "2025/09/13",
  "dateUpdated": "2025/09/13",
  "savingsArr": [
       {
      "savingsType": "highYield",
      "interestRate": "2.80",
      "intRateStartDate": "2025-09",
      "monthlyDepositAmt": "400",
      "yearArr": [
        {
          "year": "2025",
          "totalInterest": "7.4743",
          "penaltyAmt": 0
        }
      ],
      "totalDeposited": "1800.00",
      "totalTransferAmt": "0",
      "nbrTransfers": "0",
      "totalTransferFee": "0",
      "totalInterestAmt": "7.4743",
      "startDate": "2025-09",
      "closedDate": ""
    },
    {
      "savingsType": "401K",
      "interestRate": "11.00",
      "intRateStartDate": "2025-09",
      "monthlyDepositAmt": "1000",
      "yearArr": [],
      "totalDeposited": "4000.00",
      "totalTransferAmt": "0",
      "nbrTransfers": "0",
      "totalTransferFee": "0",
      "totalInterestAmt": "64.4188",
      "startDate": "2025-09",
      "closedDate": ""
    }
  ],
  "totalSavingsAmt": "5879.60"
  },
    {  // student59 
      "_id": {
        "$oid": "64011635b4f4b553e714cbe3"
      },
      "gameID": "64011299baeeb5722ca9db76",
  
  "__v": 0,
  "currentlyActive": true,
  "dateAdded": "2025/09/13",
  "dateUpdated": "2025/09/13",
  "savingsArr": [
    {
      "savingsType": "CD",
      "interestRate": "3.40",
      "intRateStartDate": "2025-09",
      "monthlyDepositAmt": 0,
      "yearArr": [
        {
          "year": "2025",
          "totalInterest": "11.3494",
          "penaltyAmt": 0
        }
      ],
      "totalDeposited": "2000",
      "totalTransferAmt": "0",
      "nbrTransfers": "0",
      "totalTransferFee": "0",
      "totalInterestAmt": "11.3494",
      "startDate": "2025-09",
      "closedDate": "",
      "autoRollover": true
    },
    {
      "savingsType": "401K",
      "interestRate": "11.00",
      "intRateStartDate": "2025-09",
      "monthlyDepositAmt": "1000",
      "yearArr": [],
      "totalDeposited": "4000.00",
      "totalTransferAmt": "0",
      "nbrTransfers": "0",
      "totalTransferFee": "0",
      "totalInterestAmt": "64.4188",
      "startDate": "2025-09",
      "closedDate": ""
    }
  ],
  "totalSavingsAmt": "6075.77"
}
   ]

export default DiscussionSavingsData